<template>
    <div class="modal fade" id="pg-product-services-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: auto;z-index: 1600;">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-black font-normal" id="exampleModalLongTitle">{{ this.editProductServicesType !== '' ? (this.editProductServicesType === 'edit' ? 'Edit' : 'Duplicate') : 'Add' }} Product/Services</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePGProductServicesModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body bg-white">
                    <div class="mt-2">
                        <label class="text-black">Type<span class="text-danger">*</span></label>
                        <select class="form-control" v-model="pgProductServicesForm.type"
                                :class="[({'border-red' : pgProductServicesForm.errors ? pgProductServicesForm.errors.has('type') : ''})]"
                                @change="resetValidation('type')">
                            <option :value="null" selected disabled>Select Type</option>
                            <option v-for="(value, key) in typesData" :value="key">{{ value }}</option>
                        </select>
                        <div class="text-red text-xs" v-if="pgProductServicesForm.errors && pgProductServicesForm.errors.has('type')">{{
                                pgProductServicesForm.errors ? pgProductServicesForm.errors.get('type') : ''}}
                        </div>
                    </div>
                    <div class="mt-2">
                        <label class="text-black">Name<span class="text-danger">*</span></label>
                        <input class="form-control" type="text" placeholder="Name" v-model="pgProductServicesForm.name"
                               :class="[({'border-red' : pgProductServicesForm.errors ? pgProductServicesForm.errors.has('name') : ''})]"
                               @input="resetValidation('name')">
                        <div class="text-red text-xs" v-if="pgProductServicesForm.errors && pgProductServicesForm.errors.has('name')">{{
                                pgProductServicesForm.errors ? pgProductServicesForm.errors.get('name') : ''}}
                        </div>
                    </div>
                    <div class="mt-2">
                        <label class="text-black">Category<span class="text-danger">*</span></label>
                        <treeselect v-model="pgProductServicesForm.category_id" :options="categoriesData" @input="resetValidation('category_id')"/>
                        <div class="text-red text-xs" v-if="pgProductServicesForm.errors && pgProductServicesForm.errors.has('category_id')">
                            {{pgProductServicesForm.errors ? pgProductServicesForm.errors.get('category_id') : ''}}
                        </div>
                    </div>
                    <div class="mt-2">
                        <label class="text-black">Description</label>
                        <textarea class="form-control" v-model="pgProductServicesForm.description"
                                  :class="[({'border-red' : pgProductServicesForm.errors ? pgProductServicesForm.errors.has('description') : ''})]"
                                  @input="resetValidation('description')">
                            </textarea>
                        <div class="text-red text-xs" v-if="pgProductServicesForm.errors && pgProductServicesForm.errors.has('description')">{{
                                pgProductServicesForm.errors ? pgProductServicesForm.errors.get('description') : ''}}
                        </div>
                    </div>
                    <div class="mt-2">
                        <label class="text-black">Sales price/rate</label>
                        <input class="form-control" type="number" placeholder="Sales price/rate" v-model="pgProductServicesForm.sales_price"
                               :class="[({'border-red' : pgProductServicesForm.errors ? pgProductServicesForm.errors.has('sales_price') : ''})]"
                               @input="resetValidation('sales_price')" min="0" oninput="(validity.valid || parseFloat(value) > 0)||(value='');">
                        <div class="text-red text-xs" v-if="pgProductServicesForm.errors && pgProductServicesForm.errors.has('sales_price')">{{
                                pgProductServicesForm.errors ? pgProductServicesForm.errors.get('sales_price') : ''}}
                        </div>
                    </div>
                    <div class="mt-2">
                        <label class="text-black">Sales tax<span class="text-danger">*</span></label>
                        <select class="form-control" v-model="pgProductServicesForm.sales_tax"
                                :class="[({'border-red' : pgProductServicesForm.errors ? pgProductServicesForm.errors.has('sales_tax') : ''})]"
                                @change="resetValidation('sales_tax')">
                            <option :value="null" selected disabled>Select Sales Tax</option>
                            <option v-for="(value, key) in salesTaxData" :value="key">{{ value }}</option>
                        </select>
                        <div class="text-red text-xs" v-if="pgProductServicesForm.errors && pgProductServicesForm.errors.has('sales_tax')">{{
                                pgProductServicesForm.errors ? pgProductServicesForm.errors.get('sales_tax') : ''}}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-10">
                            <label class="form-check-label float-left" for="exampleCheck1">Product Specs</label>
                        </div>
                        <div class="col-2" style="text-align: end;">
                            <input type="checkbox" v-model="pgIsProductSpecs" class="form-check-input float-right" id="exampleCheck1">
                        </div>
                    </div>
                    <pg-product-and-services-product-specs ref="ProductSpecs" :pg-is-product-specs="pgIsProductSpecs" :product-services-custom-field-data="productServicesCustomFieldData"></pg-product-and-services-product-specs>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="savePGProductService">
                        <i v-if="pgProductServicesFormLoader" class="fa fa-spinner fa-spin text-white"></i>
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import PgProductAndServicesProductSpecs from "../pg-product-and-services-product-specs.vue";
import Form from "../../../../../utils/form";

export default {
    name: 'pg-product-services-modal',
    props: ['typesData', 'categoriesData', 'salesTaxData', 'productServicesCustomFieldData', 'editProductServicesData', 'editProductServicesType'],
    components: {PgProductAndServicesProductSpecs, Treeselect},
    data() {
        return {
            pgIsProductSpecs: false,
            pgProductServicesForm: new Form({
                id: null,
                name: null,
                type: null,
                category_id: null,
                description: null,
                sales_price: null,
                sales_tax: null,
                productSpecs: []
            }),
            pgProductServicesFormLoader: false,
        }
    },
    watch: {
        editProductServicesData: {
            handler(val) {
                if(val !== null && val !== undefined && val.product_service_id) {
                    if(this.editProductServicesType === 'edit') {
                        this.pgProductServicesForm.id = val.product_service_id;
                    }
                    this.pgProductServicesForm.name = val.product_service_name;
                    this.pgProductServicesForm.type = val.type;
                    this.pgProductServicesForm.sales_tax = val.sales_tax;
                    this.pgProductServicesForm.sales_price = val.sales_price;
                    this.pgProductServicesForm.description = val.description;
                    this.pgProductServicesForm.category_id = val.product_service_category_id;
                    if(val.product_specs.length > 0) {
                        this.pgIsProductSpecs = true;
                        this.$refs.ProductSpecs.productSpecs = val.product_specs;
                    }
                    else {
                        this.$refs.ProductSpecs.resetProductSpecs();
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        open() {
            $('#pg-product-services-modal').modal('show');
        },
        closePGProductServicesModal() {
            $('#pg-product-services-modal').modal('hide');
            this.pgProductServicesForm.hardReset();
            this.$refs.ProductSpecs.resetProductSpecs();
            Bus.$emit('product-services-modal-closed');
        },
        savePGProductService() {
            let self = this;
            self.pgProductServicesFormLoader = true;
            self.pgProductServicesForm.productSpecs = self.$refs.ProductSpecs.productSpecs;
            self.pgProductServicesForm.post(route('api.proposal-settings.product-services.store-product-services')).then((data) => {
                self.pgProductServicesFormLoader = false;
                self.closePGProductServicesModal();
                self.pgProductServicesForm.hardReset();
                self.$refs.ProductSpecs.resetProductSpecs();
                Bus.$emit('get-all-pg-product-services');
            }).catch((error) => {
                self.pgProductServicesFormLoader = false;
            });
        },
        resetValidation(field) {
            delete this.pgProductServicesForm.errors.errors[field];
        }
    }
}
</script>
